import { createModelSegment } from 'client/data/luckdragon/segment';
import { VisitorModel } from 'client/data/models/visitor';
import { withMetrics } from 'client/data/api/api-metrics';
import { EdmundsAPI } from 'client/data/api/api-client';
import { createLeaseSpecialsAPIUrl } from 'site-modules/shared/utils/lease-deals/create-lease-specials-api-url';
import { checkIsAllValue, maybe } from 'site-modules/shared/utils/incentives/gql-incentives-filter';
import { CAR_TYPES } from 'site-modules/shared/constants/upper-funnel/car-types';
import { BODY_TYPES as LEASE_DEALS_BODY_TYPES } from 'site-modules/shared/constants/lease-deals/body-types';
import { ENGINE_TYPES as LEASE_DEALS_ENGINE_TYPES } from 'site-modules/shared/constants/lease-deals/engine-types';

const ALL_TYPES = 'all';

const getTypeLeaseDealsBodyEngineTypePath = type => {
  const bodyTypeLeaseDealsParamMap = {
    [CAR_TYPES.SUV]: LEASE_DEALS_BODY_TYPES.SUV,
    [CAR_TYPES.TRUCK]: LEASE_DEALS_BODY_TYPES.PICKUP,
    [CAR_TYPES.SEDAN]: LEASE_DEALS_BODY_TYPES.SEDAN,
    [CAR_TYPES.MINIVAN]: LEASE_DEALS_BODY_TYPES.MINIVAN,
    [CAR_TYPES.CONVERTIBLE]: LEASE_DEALS_BODY_TYPES.CONVERTIBLE,
    [CAR_TYPES.CROSSOVER]: LEASE_DEALS_BODY_TYPES.SUV,
    [CAR_TYPES.HATCHBACK]: LEASE_DEALS_BODY_TYPES.HATCHBACK,
    [CAR_TYPES.COUPE]: LEASE_DEALS_BODY_TYPES.COUPE,
    [CAR_TYPES.WAGON]: LEASE_DEALS_BODY_TYPES.STATION_WAGON,
  };

  const engineTypeLeaseDealsParamMap = {
    [CAR_TYPES.ELECTRIC]: LEASE_DEALS_ENGINE_TYPES.ELECTRIC,
    [CAR_TYPES.HYBRID]: LEASE_DEALS_ENGINE_TYPES.HYBRID,
  };

  const bodyType = bodyTypeLeaseDealsParamMap[type] || ALL_TYPES;
  const engineType = engineTypeLeaseDealsParamMap[type] || ALL_TYPES;

  return `leaseDeals["${bodyType}"]["${engineType}"]`;
};

export const TypeLeaseDealsPaths = {
  getTypeLeaseDealsBodyEngineTypePath,
};

export const TypeLeaseDealsModel = createModelSegment('typeLeaseDeals', [
  {
    /**
     * This path is used for the entry point (link) component on the type page, which redirects a user to hidden gems lease deals page
     * @see getTypeLeaseDealsBodyEngineTypePath
     */
    path: 'leaseDeals["{bodyType}"]["{engineType}"]',
    async resolve(match, context) {
      const { engineType, bodyType } = match;
      const { state } = await context.resolveValue('location', VisitorModel);

      function mapEngineTypeToExplicitValues(implicitEngineType) {
        const engineTypeMap = {
          [LEASE_DEALS_ENGINE_TYPES.HYBRID]: [
            LEASE_DEALS_ENGINE_TYPES.HYBRID,
            LEASE_DEALS_ENGINE_TYPES.MILD_HYBRID,
            LEASE_DEALS_ENGINE_TYPES.PLUG_IN_HYBRID,
          ].join(','),
        };

        return engineTypeMap?.[implicitEngineType] ?? implicitEngineType;
      }

      const url = createLeaseSpecialsAPIUrl({
        paymentRatio: '*-0.007',
        state,
        bodyType: maybe(bodyType).map(checkIsAllValue).unpack(),
        engineType: maybe(engineType).map(checkIsAllValue).map(mapEngineTypeToExplicitValues).unpack(),
        pageSize: 40,
        sortBy: 'paymentRatio',
        distinct: true,
      });

      return withMetrics(EdmundsAPI, context).fetchJson(url);
    },
  },
]);
